import React, { FC, useMemo } from 'react';

import { ProductData } from '@appcharge/shared-ui';
import { Offer } from 'common/contracts';
import { resolveProgressBarPoints } from 'views/Offers/utils/resolveProgressBarPoints';

import { DailyBonusPreview } from './components/DailyBonusPreview';
import { StandardPopupPreview } from './components/StandardPopupPreview';
import { TriggeredPopupPreview } from './components/TriggeredPopupPreview';
import { mapToPreviewProducts } from './PreviewSection.utils';

interface IProgressBarFormValues {
  progressBarId: string | null;
  progressBarPoints: number | null;
}

interface IPreviewSectionProps {
  publisherId?: string;
  currentOfferUI: string;
  isDailyBonus: boolean;
  isTriggeredPopup?: boolean;
  currentPrice: number | null;
  products: any;
  productsList: ProductData[];
  progressBarFormValues?: IProgressBarFormValues;
  progressBarOffers?: Offer[];
}

const PreviewSection: FC<IPreviewSectionProps> = ({
  publisherId,
  currentOfferUI,
  isDailyBonus,
  isTriggeredPopup = false,
  currentPrice,
  products,
  productsList,
  progressBarFormValues,
  progressBarOffers
}): React.ReactElement => {
  const previewProducts = useMemo<ProductData[]>(
    () => mapToPreviewProducts(products, productsList),
    [products, productsList]
  );

  const progressBarPoints = useMemo(
    () =>
      resolveProgressBarPoints({
        progressBarId: progressBarFormValues?.progressBarId,
        points: progressBarFormValues?.progressBarPoints,
        progressBarOffers: progressBarOffers ?? []
      }),
    [progressBarFormValues, progressBarOffers]
  );

  if (isTriggeredPopup) {
    return (
      <TriggeredPopupPreview
        publisherId={publisherId}
        currentOfferUI={currentOfferUI}
        currentPrice={currentPrice}
        previewProducts={previewProducts}
        progressBarPoints={progressBarPoints}
      />
    );
  }

  if (isDailyBonus) {
    return (
      <DailyBonusPreview
        publisherId={publisherId}
        currentOfferUI={currentOfferUI}
        previewProducts={previewProducts}
        progressBarPoints={progressBarPoints}
      />
    );
  }

  return (
    <StandardPopupPreview
      publisherId={publisherId}
      currentOfferUI={currentOfferUI}
      currentPrice={currentPrice}
      previewProducts={previewProducts}
      progressBarPoints={progressBarPoints}
    />
  );
};

export { PreviewSection };
export default PreviewSection;
